module.exports = __webpack_public_path__ + "img/estipulacionsaee.90a8fcf8.svg";